import { getClientHost } from '../helpers/client';
import { getOrCreateEncodedUUID } from '../helpers/user-meta';
import { getLanguageAndQueryParams } from '../helpers/language';

const userId = getOrCreateEncodedUUID();

/**
 * GET /selector/{selector_id}
 * Fetches Playbook Prediction data from Fan API
 *
 * @param {string} selectorId - Playbook Team selector selectorId
 * @param {string} isGated - is the selector gated
 * @param {string} authHeader - auth header
 * @returns {Promise} -
 */
export const getTeamSelectorData = (selectorId, isGated, authHeader) => {
    const { queryParams } = getLanguageAndQueryParams();

    const TEAM_SELECTOR_HOST = `${getClientHost()}${process.env.API_PATH}`;
    const endpoint = isGated
        ? `https://${TEAM_SELECTOR_HOST}/gated/selectors/${selectorId}${queryParams}`
        : `https://${TEAM_SELECTOR_HOST}/selectors/${selectorId}${queryParams}`;

    const headers = {
        'Content-Type': 'application/json',
        ...(!isGated && { 'X-User-Id': userId })
    };

    if (isGated && authHeader) {
        headers.Authorization = authHeader;
    }

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            headers
        })
            .then((response) => {
                if (!response.ok) {
                    console.warn(
                        'Playbook - Team selector embed unsuccessful',
                        selectorId
                    );
                    return null;
                }

                return response.json();
            })
            .then((selectorData) => {
                resolve(selectorData);
            })
            .catch((error) => {
                console.error(
                    'Playbook - Team selector embed unsuccessful',
                    error
                );
                reject(error);
            });
    });
};

/**
 * POST /selectors/{selector_id}/answers
 * Submit an answer to a selector
 *
 * @param {string} selectorId - Team selector ID
 * @param {string} payload - answer
 * @param {string} isGated - should it be gated
 * @param {string} authHeader - auth header
 * @returns {Promise} -
 */
export const sendAnswer = (selectorId, payload, isGated, authHeader) => {
    const TEAM_SELECTOR_HOST = `${getClientHost()}${process.env.API_PATH}`;

    const endpoint = isGated
        ? `https://${TEAM_SELECTOR_HOST}/gated/selectors/${selectorId}/answers`
        : `https://${TEAM_SELECTOR_HOST}/selectors/${selectorId}/answers`;

    const headers = {
        'Content-Type': 'application/json',
        // Set X-User-Id only if not gated
        ...(!isGated && { 'X-User-Id': userId }),
        // Set Authorization only if gated and authHeader is present
        ...(isGated && authHeader && { Authorization: authHeader })
    };

    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (
                    response.status &&
                    !response.status.toString().match(/2\d{2}/g)
                ) {
                    // Non sucessful response
                    reject(response);
                    return;
                }
                resolve(response);
            })
            .catch((error) => {
                console.error(
                    'Playbook - Team selector submission answer unsuccessful.',
                    error
                );
                reject(error);
            });
    });
};

export const getTeamSelectorIdByMatchId = (matchId) => {
    const endpoint = `https://${getClientHost()}${
        process.env.API_SDP_ADAPTOR_API
    }/matches/${matchId}`;

    return fetch(endpoint)
        .then((response) => response.json())
        .catch((error) => {
            console.warn(
                'Playbook Team Selector embed error fetching match data',
                error
            );
        });
}